var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.2,
    height: 18.199,
    viewBox: "0 0 18.2 18.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Search_4026089",
    transform: "translate(-20.653 -16.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34819",
    "data-name": "Group 34819",
    transform: "translate(20.653 16.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M8.231.516a7.719,7.719,0,1,0,4.781,13.777l4.156,4.156a.905.905,0,0,0,1.284-1.277l-4.159-4.159A7.715,7.715,0,0,0,8.231.516Zm0,1.8A5.919,5.919,0,1,1,4.055,4.052,5.887,5.887,0,0,1,8.233,2.316Z",
    transform: "translate(-0.516 -0.516)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.7627ccf542f6e3f1e15f70f14ffc4294.svg";
export { ForwardRef as ReactComponent };